module.exports = __webpack_public_path__ + "img/22.0665b0b3.jpg";